import { useTranslation } from "react-i18next";

import { Typography } from "@digital-services/ui";
import { BasicKeyValuePairTruncated } from "@ds-cps/ui";

import { BasicKeyValuePair } from "@components/for_drawer/BasicKeyValuePair";

import { AuditLogModel } from "@audit-log/models";

import { formatterShort } from "@utils/time-utils";

import { AuditLogEventPayload } from "../AuditLogEventPayload";

interface Props {
  data: AuditLogModel;
}

export const LogDetailsDrawerContent = ({ data }: Props) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: "audit-log"
  });

  return (
    <>
      <div
        className={`grid w-full max-w-[500px] grid-cols-[1fr_2fr] gap-4 sm:w-fit`}
        data-testid="audit-log-details-details"
      >
        <BasicKeyValuePair
          baseKey={t("table.headers.timestamp")}
          baseValue={formatterShort(data.timestamp)}
        />
        <BasicKeyValuePair
          baseKey={t("table.headers.id")}
          baseValue={data.id}
        />
        <BasicKeyValuePair
          baseKey={t("table.headers.userContextEmail")}
          baseValue={data.userContextEmail || "-"}
        />
        <BasicKeyValuePairTruncated
          baseKey={t("table.headers.organization")}
          baseValue={data.organization || "-"}
        />
        <BasicKeyValuePair
          baseKey={t("table.headers.resource")}
          baseValue={data.resource || "-"}
        />
        <BasicKeyValuePair
          baseKey={t("table.headers.application")}
          baseValue={data.application || "-"}
        />
        <BasicKeyValuePair
          baseKey={t("table.headers.userEmail")}
          baseValue={data.userEmail || "-"}
        />
        <BasicKeyValuePair
          baseKey={t("table.headers.sourceApplicationName")}
          baseValue={data.sourceApplicationName || "-"}
        />
        <BasicKeyValuePair
          baseKey={t("table.headers.action")}
          baseValue={data.action || "-"}
        />
        <Typography className="self-start">{t("drawer.payload")}</Typography>
      </div>
      <AuditLogEventPayload data={data.payload} />
    </>
  );
};
